import apiClient from 'src/Common/apiClient'

// apiClient attaches a fresh Bearer token per request; no stale import-time token here.
// Mentor details fetch karne ka function
export const fetchMentorDetail = async (id) => {
  try {
    const response = await apiClient.get(`/IdeaFactoryProgram/Mentor/Detail?programId=${id}`)
    return response.data
  } catch (error) {
    console.error('Error fetching details:', error)
    throw error
  }
}

// Resubmission toggle API call
export const toggleResubmission = async (templateId) => {
  try {
    await apiClient.post(`/IdeaFactoryProgram/Toggle-Resubmission?templateId=${templateId}`, {})
  } catch (error) {
    console.error('Error toggling resubmission:', error)
    throw error
  }
}

export const fileSharing = async (id) => {
  try {
    const response = await apiClient.get(
      `/IdeaFactoryProgram/Mentor/Share-ProjectPlan?programId=${id}`,
    )
    return response.data
  } catch (error) {
    console.error('Error fetching details:', error)
    throw error
  }
}
